var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneFlip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.907 351.25L127.392 304.749C140.173 299.218 155.188 302.937 163.876 313.718L207.923 367.531C277.173 333.531 333.47 277.249 367.454 208.029L313.626 163.935C302.876 155.154 299.204 140.279 304.642 127.497L351.173 18.934C357.267 5.027 372.345 -2.598 387.032 0.809L487.782 24.059C502.032 27.309 512.001 39.84 512.001 54.497C512.001 306.78 306.767 512.001 54.517 512.001C39.845 512.001 27.313 502.032 24.048 487.782L0.798 387C-2.577 372.406 5.001 357.25 18.907 351.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFlip);
export default __webpack_public_path__ + "static/media/phone-flip.6953d9f5bf98c3c05097ac4076f0c654.svg";
export { ForwardRef as ReactComponent };